import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { admitEntry } from 'features/users/actions';

export function* admitEntrySaga(action: ReturnType<typeof admitEntry>) {
  yield call(SignalingSocket.send, {
    event: 'admitUserAccess',
    data: {
      id: action.payload.userId,
      roomId: action.payload.roomId,
    },
  });
}
